import Button from "../component/ui/button";
import Input from "../component/ui/input";
import Card from "../component/ui/card";
import { FaPlaneDeparture, FaHotel, FaShip, FaLandmark, FaFileAlt, FaUmbrellaBeach, FaSearch } from "react-icons/fa";

function Header() {
    return (
        <div className="min-h-screen bg-cover bg-center bg-black opacity-80 " style={{ backgroundImage: "url('/image/slideshow/dubai.jpg')" }}>
            <div className="flex justify-between items-center p-6 text-white bg-opacity-30 bg-black">
                <div className="flex items-center gap-2">
                    <img src="../image/Logo-AlamTrans.png" alt="Logo" className="h-12" />
                </div>
                <div className="hidden md:flex gap-6 text-white font-medium">
                    <a href="/flights">Flights</a>
                    <a href="/hotels">Hotels</a>
                    <a href="/travel">Travel Packages</a>
                    <a href="/cruises">Cruises</a>
                    <a href="/attraction">Attractions</a>
                    <a href="/document">Document & Visa</a>
                    <a href="/insurance">Travel Insurance</a>
                </div>
                <div className="flex gap-4">
                    <Button className="text-blue-500">Sign In</Button>
                    <Button variant="outline">Register</Button>
                </div>
            </div>

            {/* Hero */}
            <div className="text-center text-white pt-20 pb-10">
                <h1 className="text-4xl font-bold">Turn your holiday dreams into reality today!</h1>
            </div>

            {/* Booking Section */}
            <Card className="max-w-6xl mx-auto bg-black bg-opacity-60">
                <div className="p-6">
                    <div className="flex flex-wrap justify-center gap-4 text-white mb-6">
                        <div className="flex items-center gap-2"><FaPlaneDeparture /> Flights</div>
                        <div className="flex items-center gap-2"><FaHotel /> Hotels</div>
                        <div className="flex items-center gap-2"><FaShip /> Cruises</div>
                        <div className="flex items-center gap-2"><FaLandmark /> Attractions</div>
                        <div className="flex items-center gap-2"><FaFileAlt /> Document & Visa</div>
                        <div className="flex items-center gap-2"><FaUmbrellaBeach /> Travel Insurance</div>
                    </div>

                    {/* Tabs */}
                    <div className="flex justify-center gap-6 mb-6">
                        <Button variant="secondary">One-Way</Button>
                        <Button variant="ghost">Round-Trip</Button>
                    </div>

                    {/* Form */}
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
                        <div>
                            <label className="text-white">From</label>
                            <Input placeholder="Jakarta JKT" />
                        </div>
                        <div>
                            <label className="text-white">To</label>
                            <Input placeholder="Osaka OSA" />
                        </div>
                        <div>
                            <label className="text-white">Departure date</label>
                            <Input type="date" defaultValue="2025-09-25" />
                        </div>
                        <div>
                            <label className="text-white">Passenger, Class</label>
                            <Input defaultValue="1, Business" />
                        </div>
                        <div>
                            <Button className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2"><FaSearch className="mr-2" />Search </Button>
                        </div>
                    </div>
                </div>
            </Card>
        </div >
    );
}

export default Header;
